import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { YERALDIN_MARRERO_ANCHOR_SRC } from '../brandAssets';

const ANCHOR_IMAGE = YERALDIN_MARRERO_ANCHOR_SRC;

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '20vh',
          }}
        />
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          gutterBottom
          align={'center'}
          color={theme.palette.primary.main}
        >
          TNO Sports: la agenda deportiva de TNO Network con pasión y análisis
        </Box>
        <Typography
          variant={'h6'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
        >
          El espacio deportivo de la primera radio audiovisual de Venezuela: fútbol, béisbol, agenda nacional e internacional, entrevistas y cobertura con el sello TNO. Tu marca junto a la pasión que mueve millones de fanáticos.
        </Typography>
        <Typography
          variant={'h5'}
          component={'p'}
          color={theme.palette.primary.main}
          align={'center'}
          sx={{ mt: 3, mb: 2, fontStyle: 'italic' }}
        >
          ¿Qué es TNO Sports?
        </Typography>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://tnonetwork.com/show/tnosports"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            tnonetwork.com/show/tnosports
          </Link>
        </Typography>
        <Typography
          variant={'body1'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
          sx={{ mt: 1 }}
        >
          Programa deportivo ganador del <strong>TNO Radio Award</strong> a Mejor Programa Deportivo. Agenda, análisis y conversación con invitados del mundo del deporte. Presencia en vivo, On-Demand y redes del ecosistema TNO Network.
        </Typography>
      </Box>

      <Box marginTop={6} marginBottom={4}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={3}>
            <Box display="flex" justifyContent="center">
              <Box
                component="img"
                src={ANCHOR_IMAGE}
                alt="Yeraldin Marrero - Ancla de TNO Sports"
                sx={{
                  width: { xs: 200, sm: 250, md: 300 },
                  height: { xs: 200, sm: 250, md: 300 },
                  borderRadius: 2,
                  objectFit: 'cover',
                  objectPosition: 'center top',
                  boxShadow: 3,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={9}>
            <Typography
              variant={'h5'}
              fontWeight={700}
              gutterBottom
              color={theme.palette.primary.main}
            >
              NUESTRA ANCLA: YERALDIN MARRERO
            </Typography>
            <Typography
              variant={'body2'}
              color={'textSecondary'}
              sx={{ fontStyle: 'italic', mb: 2 }}
            >
              La voz que conduce la agenda deportiva de TNO Network
            </Typography>
            <Typography variant={'body1'} color={'textSecondary'}>
              <strong>Yeraldin Marrero</strong> conduce <strong>TNO Sports</strong> en TNO Network: periodista y comunicadora deportiva con{' '}
              <strong>más de 100 mil seguidores en Instagram</strong>, referencia para la audiencia digital que consume deporte en redes.
              En antena y en terreno conecta con fanáticos, atletas y directivos: agenda, fútbol, béisbol, Vinotinto y cobertura de eventos con cercanía y credibilidad.
              Ideal para marcas de deporte, bebidas, retail, telecomunicaciones y patrocinios.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Who;
